/**
 * Enum containing all permission codes used in the application.
 * These codes must match the permissionCode values returned from the API.
 */
export enum PermissionCode {
  VIEW = 'VIEW',
  GENERATE = 'GENERATE',
  EXPORT = 'EXPORT',
  PRINT = 'PRINT',
}
